import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";

// import { Dots, Navigation } from "@fancyapps/ui";

const featuredProductCarousel = document.querySelectorAll(
	".featured-product-carousel"
);
if (featuredProductCarousel.length > 0) {
	featuredProductCarousel.forEach((carousel) => {
		const options = {
			adaptiveHeight: true,
			Navigation: false,
			transition: "slide",
			Dots: {
				classes: {
					list: "f-carousel__dots featured-product-carousel__dots",
					dot: "f-carousel__dot featured-product-carousel__dot",
				},
			},
		};
		const carouselInstance = new Carousel(carousel, options);

		carousel
			.querySelector(".featured-product-carousel-nav__prev")
			.addEventListener("click", () => {
				carouselInstance.slidePrev();
			});
		carousel
			.querySelector(".featured-product-carousel-nav__next")
			.addEventListener("click", () => {
				carouselInstance.slideNext();
			});
	});
}
